import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { FornecedorEditarComponent } from './fornecedor-editar.component';


@NgModule({
    imports: [RouterModule.forChild([
        { path: ':id', component: FornecedorEditarComponent }
    ])],
    exports: [RouterModule]
})
export class FornecedorEditarRoutingModule { }
